import gql from 'graphql-tag'

export const HEADER_QUERY = gql`
query {
  setting {
    data {
      attributes {
        header {
          logo {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          logoAlternate {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
        }
      }
    }
  }
}
`;
